import { render, staticRenderFns } from "./MainPageStandalone.vue?vue&type=template&id=0fb7987f&scoped=true"
import script from "./MainPageStandalone.vue?vue&type=script&lang=js"
export * from "./MainPageStandalone.vue?vue&type=script&lang=js"
import style0 from "./MainPageStandalone.vue?vue&type=style&index=0&id=0fb7987f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb7987f",
  null
  
)

export default component.exports